import React from 'react';
import { ReactComponent as Icon } from '../svg/spinner.svg';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

import { colors } from '@modernhealth/vital-foundation';

interface Props {
    className?: string;
    color?: string;
    size?: number;
}

export const CenteredSpinnerTestId = 'centered-spinner';

const rotate = keyframes`
    0% {
        transform: rotate(0);
    }

    100% {
        transform: rotate(360deg);
     }
`;

const fadeIn = keyframes`
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
     }
`;

// Keep using absolute (instead of flexbox positioning)
// to prevent adding a lot of overriding styles to parent divs
// during Ant-d migration.
const SpinnerWrapper = styled('div')({
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
});

// Add fade-in effect to make the spinner appear smoother
// (preventing spinner flashing in and out) while always show spinner
// when UI enters the loading state.
const SpinnerIcon = styled(Icon)({
    opacity: 0,
    animationName: `${rotate}, ${fadeIn}`,
    animationDuration: '650ms, 1000ms',
    animationTimingFunction: 'cubic-bezier(.645, .045, .355, 1), ease',
    animationIterationCount: 'infinite, 1',
    animationFillMode: 'forwards',
});

export const Spinner = ({ color, size, className }: Props) => (
    <SpinnerIcon
        className={className}
        css={{
            color,
            width: `${size}px`,
            height: `${size}px`,
        }}
    />
);

export const CenteredSpinner: React.FunctionComponent<Props> = ({
    color = colors.blue55,
    size = 32,
    className,
}) => (
    <SpinnerWrapper className={className} data-testid={CenteredSpinnerTestId}>
        <Spinner color={color} size={size} />
    </SpinnerWrapper>
);
